<div *ngIf="showMe">
    <tds-modal show="true" (tdsClose)="closeDialog()" header="Action needed" size="md">
        <span slot="body">
            <h3>Active Consultant on inactive assignment</h3>
            <p style="text-align: justify;"> There is one or more assignments where end date has passed but that still have
                active consultant(s) assigned. Check "Inactive Only" and "Active Consultants Only" in the menu to inspect.
            </p>
        </span>

        <span slot="actions">
            <tds-button
                data-dismiss-modal
                type="button"
                variant="primary"
                size="md"
                text="Close">
            </tds-button>
        </span>
    </tds-modal>
</div>